import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import type { PreCashinInfo } from '../../../../../../../../../types/Cashier';
import { Messages, getBonusMessage } from '../../../../../../../../../utils/bonus';
import TicketSetRecord from '../../../../../TicketSetRecord/TicketSetRecord';

import { TXTCLI_Each_ticket_set_consists_of_th_ELL } from './DefaultTicketsBonus.messages.json';

interface Props {
  isFirst: boolean;
  bonus: number;
  isSingleTicketInSet: boolean;
  bonusFormatted: JSX.Element | number;
  formattedAmount: JSX.Element;
}

const DefaultTicketsBonus: React.FC<Props> = ({
  isFirst,
  bonus,
  bonusFormatted,
  formattedAmount,
  isSingleTicketInSet
}) => {
  const {
    data: { preCashinInfo }
  } = useWizardContext();

  const { ticketSet, fppToExercise } = preCashinInfo as PreCashinInfo;
  const translation: TranslationTag = getBonusMessage(
    isFirst ? Messages.RewardFirst : Messages.RewardYour,
    isSingleTicketInSet,
    bonus === 1
  );

  if (isSingleTicketInSet) {
    return (
      <Translation
        tagName="p"
        {...translation}
        values={{
          0: formattedAmount,
          1: bonus === 1 ? fppToExercise : bonusFormatted,
          2: fppToExercise
        }}
      />
    );
  }

  return (
    <>
      <Translation
        tagName="p"
        {...translation}
        values={{
          0: formattedAmount,
          1: fppToExercise,
          2: bonusFormatted
        }}
      />
      <Translation
        tagName="p"
        {...TXTCLI_Each_ticket_set_consists_of_th_ELL}
        values={{
          0: formattedAmount,
          1: fppToExercise,
          2: bonusFormatted
        }}
      />
      <TicketSetRecord ticketSet={ticketSet} />
    </>
  );
};

export default DefaultTicketsBonus;
